module.exports = window["core-js/modules/es.symbol.to-primitive.js"];